import styles from "../../../assets/css/popups/addinvoicepopup.module.css";
import BackBtn from "../../backbtn";
import { JSFunctions } from "../../../App";
import { useDispatch } from "react-redux";
import Toasts from "../../../assets/toasts/toasts";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import Overlay from "../../overlay";

function GiveSalaryPopup(props) {
  const [overlay, setOverlayState] = useState(false);
  const [lastGiveSalary, setLastGiveSalary]  = useState("");
  let [salary,setSalary] = useState(0);
  let [date, setDate] = useState("");

  const dispatch = useDispatch();
  const Toast = new Toasts();

  function cancle() {
    console.log(props);
    dispatch({ type: "", payload: { giveSalaryWidgetState: false } });
  }
  async function giveSalary(){
    if (date.length === 0) {
      Toast.error("يجب إدخال التاريخ أولا")
    }else {
      const now = new Date();
      const hour = now.getHours().toString().padStart(2, '0');
      const minute = now.getMinutes().toString().padStart(2, '0');
      const formattedDate = `${date}-${hour}-${minute}`;
      const uploadData = {
          date: formattedDate,
          name: props.selectedEmployeeName,
          salary: salary
      }
      let functions = new JSFunctions();
      setOverlayState(true);
      let res = await functions.giveSalary(uploadData);
      setOverlayState(false);
      console.log(res)
      if (!res) {
          Toast.error("حدث خطأ.");
      } else {
          Toast.success("تم تسليم الراتب")
      }
    }
       
   }
 
  async function getEmployees(){
    let functions = new JSFunctions();
    setOverlayState(true);
    let employees = await functions.getEmployees();
    setOverlayState(false);
    employees.forEach((ele,index)=>{
        ele = JSON.parse(ele);
        if (ele["name"] === props.selectedEmployeeName) {
            setSalary(ele["salary"]);
            if (JSON.parse(ele["history"]).length === 0) {
                Toast.error("لم يحصل هذا الموظف علي راتب مسبقا")
            }else {
                let history = JSON.parse(ele["history"])
                let date = history[history.length - 1]["date"].split("-").slice(0,3).join("-");
                setLastGiveSalary(date)
            }
        }
    })
  }
  useEffect(()=>{
    getEmployees();
  },[])
  return (
    <>
      <div className={styles["popup"]}>
        <div className={styles.header}>
          <h2 className={styles["title"]}>تسليم مرتب ({props.selectedEmployeeName})</h2>
          <div onClick={() => cancle("giveSalaryWidgetState")}>
            <BackBtn />
          </div>
        </div>
        <input readOnly placeholder={`أخر موعد تسليم للراتب: ${lastGiveSalary}`}></input>
        <h4>تاريخ تسليم الراتب:</h4>
        <input type="date" onChange={(ele)=>setDate(ele.target.value)}></input>

      <button onClick={giveSalary}>حفظ</button>

      </div>
      <Toaster position="top-left" reverseOrder={false} />
      {overlay ? <Overlay></Overlay> : null}
    </>
  );
}

export default GiveSalaryPopup;
